/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Temperature Icon component.
 */
export const TemperatureIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13.9077 13.2619V3.45526C13.9077 2.80408 13.6442 2.17958 13.1754 1.71913C12.7066 1.25868 12.0707 1 11.4077 1C10.7464 1.0026 10.113 1.26238 9.64636 1.72255C9.17968 2.18272 8.91771 2.80578 8.91772 3.45526V14.9612C8.12713 15.5053 7.53564 16.2845 7.23059 17.184C6.92554 18.0835 6.92309 19.0555 7.22363 19.9565C7.52417 20.8574 8.1118 21.6396 8.89965 22.1874C9.68751 22.7353 10.6339 23.0198 11.599 22.9989C12.5641 22.9781 13.4967 22.653 14.2593 22.0716C15.0218 21.4903 15.5739 20.6835 15.8338 19.7705C16.0937 18.8574 16.0478 17.8864 15.7027 17.001C15.3577 16.1155 14.7319 15.3625 13.9177 14.8531L13.9077 13.2619Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' />
      <path d='M9 5L11.2 5' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M9 8L11.2 8' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
      <path d='M9 11L11.2 11' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round' />
    </svg>
  );
};

export default TemperatureIcon;
